import React from "react";
import { useNavigate } from "react-router-dom";
import CurrentStudyList from "../../components/DashboardInfo/CurrentStudyList";
import { ThemButton } from "../../components/Login/Login.style";
import { MainDiv } from "../../components/Profile/Profile.style";
import { SearchAddDiv } from "../../components/style/Table.style";
import { VolunteerHeading } from "../../components/Volunteer/Volunteer.style";
import useProfile from "../../hooks/useProfile";
import CurrentTrialList from "./CurrentTrialList";

const TrialPage = () => {
  const navigate = useNavigate();
  const [userData, isLoading] = useProfile();
  if (isLoading) {
    return "";
  }
  const user = userData.ugleve_name;

  const moveDashboard = () => {
    navigate("/");
  };
  return (
    <MainDiv>
      <SearchAddDiv>
        <VolunteerHeading>Current Trials</VolunteerHeading>
        <div>
          <ThemButton onClick={() => moveDashboard()}>
            Back to dashboard
          </ThemButton>
        </div>
      </SearchAddDiv>
      <CurrentTrialList user={user} />
    </MainDiv>
  );
};

export default TrialPage;
